import React, { Fragment } from 'react';
import Dog from './Component/dog';

export default function Career() {
  return (
    <Fragment>
      <div>Career Page</div>
      <Dog />
    </Fragment>
  );
}
